export default __webpack_public_path__ + "static/media/misc004.f8d4b8a8.jpeg";